import state from './state.js'
import getters from './getters.js'
import actions from './actions.js'

const storeOptions = {
  state,
  getters,
  actions
}

export const useUserStore = defineStore('user', storeOptions)
